
import React, { useState, useEffect } from 'react';
import { Bell, X } from 'lucide-react';
import { useAppContext } from '../../App.jsx';

const NotificationPrompt = () => {
    const { firebase, fullUserData } = useAppContext();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Só mostra se:
        // 1. O usuário está logado
        // 2. Notificações não estão autorizadas nem negadas (default)
        // 3. O usuário ainda não fechou este banner nesta sessão (ou nos últimos dias)
        const checkPermission = async () => {
            if (!firebase?.user) return;

            const hasClosed = localStorage.getItem('tservi_notif_prompt_closed');
            const now = Date.now();

            // Se fechou há menos de 3 dias, não mostra de novo
            if (hasClosed && (now - parseInt(hasClosed)) < (3 * 24 * 60 * 60 * 1000)) {
                return;
            }

            if ('Notification' in window) {
                if (Notification.permission === 'default') {
                    // Delay para não aparecer na cara do usuário assim que abre o app
                    setTimeout(() => setIsVisible(true), 5000);
                }
            }
        };

        checkPermission();
    }, [firebase?.user]);

    const handleEnable = async () => {
        setIsVisible(false);
        if (firebase?.requestNotificationPermission) {
            await firebase.requestNotificationPermission();
        }
    };

    const handleClose = () => {
        setIsVisible(false);
        localStorage.setItem('tservi_notif_prompt_closed', Date.now().toString());
    };

    if (!isVisible) return null;

    return (
        <div className="fixed top-20 left-4 right-4 z-[100] animate-in fade-in slide-in-from-top-4 duration-500">
            <div className="bg-white border-2 border-blue-500 rounded-3xl shadow-2xl p-4 flex items-center space-x-4">
                <div className="bg-blue-100 p-3 rounded-2xl shrink-0">
                    <Bell className="text-blue-600 animate-bounce" size={24} />
                </div>
                <div className="flex-1 text-left">
                    <h4 className="text-sm font-black text-gray-800 uppercase tracking-tighter">Ativar Notificações?</h4>
                    <p className="text-[10px] text-gray-500 font-bold leading-tight">Receba alertas de novos orçamentos e mensagens em tempo real.</p>
                </div>
                <div className="flex flex-col space-y-2">
                    <button
                        onClick={handleEnable}
                        className="bg-blue-600 text-white text-[10px] font-black uppercase px-4 py-2 rounded-xl shadow-md active:scale-95 transition-all"
                    >
                        Sim
                    </button>
                    <button
                        onClick={handleClose}
                        className="text-gray-400 p-1 hover:text-gray-600 self-center"
                    >
                        <X size={16} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotificationPrompt;
